class $bcb8d116ab6e5930$export$931cbfb6bfb85fc {
    container;
    constructor(containerHTML){
        this.container = containerHTML;
        this.container.addEventListener("click", this.toggleMenu.bind(this));
        window.addEventListener("click", this.closeMenuOnClick.bind(this));
    }
    toggleMenu() {
        const dropdownMenu = this.container.querySelector(".dropdown__menu");
        dropdownMenu.classList.toggle("show");
    }
    closeMenuOnClick(event) {
        if (!event.target.matches(".dropdown__trigger")) {
            let dropdowns = document.getElementsByClassName("dropdown__menu");
            let i;
            for(i = 0; i < dropdowns.length; i++){
                let openDropdown = dropdowns[i];
                if (openDropdown.classList.contains("show")) openDropdown.classList.remove("show");
            }
        }
    }
}


function $f426e192429150b2$var$e(e, t) {
    for(var o = 0; o < t.length; o++){
        var n = t[o];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
    }
}
function $f426e192429150b2$var$t(e) {
    return function(e) {
        if (Array.isArray(e)) return $f426e192429150b2$var$o(e);
    }(e) || function(e) {
        if ("undefined" != typeof Symbol && Symbol.iterator in Object(e)) return Array.from(e);
    }(e) || function(e, t) {
        if (!e) return;
        if ("string" == typeof e) return $f426e192429150b2$var$o(e, t);
        var n = Object.prototype.toString.call(e).slice(8, -1);
        "Object" === n && e.constructor && (n = e.constructor.name);
        if ("Map" === n || "Set" === n) return Array.from(e);
        if ("Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $f426e192429150b2$var$o(e, t);
    }(e) || function() {
        throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }();
}
function $f426e192429150b2$var$o(e, t) {
    (null == t || t > e.length) && (t = e.length);
    for(var o = 0, n = new Array(t); o < t; o++)n[o] = e[o];
    return n;
}
var $f426e192429150b2$var$n, $f426e192429150b2$var$i, $f426e192429150b2$var$a, $f426e192429150b2$var$r, $f426e192429150b2$var$s, $f426e192429150b2$var$l = ($f426e192429150b2$var$n = [
    "a[href]",
    "area[href]",
    'input:not([disabled]):not([type="hidden"]):not([aria-hidden])',
    "select:not([disabled]):not([aria-hidden])",
    "textarea:not([disabled]):not([aria-hidden])",
    "button:not([disabled]):not([aria-hidden])",
    "iframe",
    "object",
    "embed",
    "[contenteditable]",
    '[tabindex]:not([tabindex^="-"])'
], $f426e192429150b2$var$i = function() {
    function o(e) {
        var n = e.targetModal, i = e.triggers, a = void 0 === i ? [] : i, r = e.onShow, s = void 0 === r ? function() {} : r, l = e.onClose, c = void 0 === l ? function() {} : l, d = e.openTrigger, u = void 0 === d ? "data-micromodal-trigger" : d, f = e.closeTrigger, h = void 0 === f ? "data-micromodal-close" : f, v = e.openClass, g = void 0 === v ? "is-open" : v, m = e.disableScroll, b = void 0 !== m && m, y = e.disableFocus, p = void 0 !== y && y, w = e.awaitCloseAnimation, E = void 0 !== w && w, k = e.awaitOpenAnimation, M = void 0 !== k && k, A = e.debugMode, C = void 0 !== A && A;
        !function(e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, o), this.modal = "string" == typeof n ? document.getElementById(n) : n, this.config = {
            debugMode: C,
            disableScroll: b,
            openTrigger: u,
            closeTrigger: h,
            openClass: g,
            onShow: s,
            onClose: c,
            awaitCloseAnimation: E,
            awaitOpenAnimation: M,
            disableFocus: p
        }, a.length > 0 && this.registerTriggers.apply(this, $f426e192429150b2$var$t(a)), this.onClick = this.onClick.bind(this), this.onKeydown = this.onKeydown.bind(this);
    }
    var i, a, r;
    return i = o, a = [
        {
            key: "registerTriggers",
            value: function() {
                for(var e = this, t = arguments.length, o = new Array(t), n = 0; n < t; n++)o[n] = arguments[n];
                o.filter(Boolean).forEach(function(t) {
                    t.addEventListener("click", function(t) {
                        return e.showModal(t);
                    });
                });
            }
        },
        {
            key: "showModal",
            value: function() {
                var e = this, t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : null;
                if (this.activeElement = document.activeElement, this.modal.setAttribute("aria-hidden", "false"), this.modal.classList.add(this.config.openClass), this.scrollBehaviour("disable"), this.addEventListeners(), this.config.awaitOpenAnimation) {
                    var o = function t() {
                        e.modal.removeEventListener("animationend", t, !1), e.setFocusToFirstNode();
                    };
                    this.modal.addEventListener("animationend", o, !1);
                } else this.setFocusToFirstNode();
                this.config.onShow(this.modal, this.activeElement, t);
            }
        },
        {
            key: "closeModal",
            value: function() {
                var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : null, t = this.modal;
                if (this.modal.setAttribute("aria-hidden", "true"), this.removeEventListeners(), this.scrollBehaviour("enable"), this.activeElement && this.activeElement.focus && this.activeElement.focus(), this.config.onClose(this.modal, this.activeElement, e), this.config.awaitCloseAnimation) {
                    var o = this.config.openClass;
                    this.modal.addEventListener("animationend", function e() {
                        t.classList.remove(o), t.removeEventListener("animationend", e, !1);
                    }, !1);
                } else t.classList.remove(this.config.openClass);
            }
        },
        {
            key: "closeModalByIdOrElement",
            value: function(e) {
                this.modal = "string" == typeof e ? document.getElementById(e) : e, this.modal && this.closeModal();
            }
        },
        {
            key: "scrollBehaviour",
            value: function(e) {
                if (this.config.disableScroll) {
                    var t = document.querySelector("body");
                    switch(e){
                        case "enable":
                            Object.assign(t.style, {
                                overflow: ""
                            });
                            break;
                        case "disable":
                            Object.assign(t.style, {
                                overflow: "hidden"
                            });
                    }
                }
            }
        },
        {
            key: "addEventListeners",
            value: function() {
                this.modal.addEventListener("touchstart", this.onClick), this.modal.addEventListener("click", this.onClick), document.addEventListener("keydown", this.onKeydown);
            }
        },
        {
            key: "removeEventListeners",
            value: function() {
                this.modal.removeEventListener("touchstart", this.onClick), this.modal.removeEventListener("click", this.onClick), document.removeEventListener("keydown", this.onKeydown);
            }
        },
        {
            key: "onClick",
            value: function(e) {
                (e.target.hasAttribute(this.config.closeTrigger) || e.target.parentNode.hasAttribute(this.config.closeTrigger)) && (e.preventDefault(), e.stopPropagation(), this.closeModal(e));
            }
        },
        {
            key: "onKeydown",
            value: function(e) {
                27 === e.keyCode && this.closeModal(e), 9 === e.keyCode && this.retainFocus(e);
            }
        },
        {
            key: "getFocusableNodes",
            value: function() {
                var e = this.modal.querySelectorAll($f426e192429150b2$var$n);
                return Array.apply(void 0, $f426e192429150b2$var$t(e));
            }
        },
        {
            key: "setFocusToFirstNode",
            value: function() {
                var e = this;
                if (!this.config.disableFocus) {
                    var t = this.getFocusableNodes();
                    if (0 !== t.length) {
                        var o = t.filter(function(t) {
                            return !t.hasAttribute(e.config.closeTrigger);
                        });
                        o.length > 0 && o[0].focus(), 0 === o.length && t[0].focus();
                    }
                }
            }
        },
        {
            key: "retainFocus",
            value: function(e) {
                var t = this.getFocusableNodes();
                if (0 !== t.length) {
                    if (t = t.filter(function(e) {
                        return null !== e.offsetParent;
                    }), this.modal.contains(document.activeElement)) {
                        var o = t.indexOf(document.activeElement);
                        e.shiftKey && 0 === o && (t[t.length - 1].focus(), e.preventDefault()), !e.shiftKey && t.length > 0 && o === t.length - 1 && (t[0].focus(), e.preventDefault());
                    } else t[0].focus();
                }
            }
        }
    ], $f426e192429150b2$var$e(i.prototype, a), r && $f426e192429150b2$var$e(i, r), o;
}(), $f426e192429150b2$var$a = null, $f426e192429150b2$var$r = function(e) {
    if ("string" == typeof id ? !document.getElementById(e) : !e) return console.warn("MicroModal: \u2757Seems like you have missed %c'".concat(e, "'"), "background-color: #f8f9fa;color: #50596c;font-weight: bold;", "ID somewhere in your code. Refer example below to resolve it."), console.warn("%cExample:", "background-color: #f8f9fa;color: #50596c;font-weight: bold;", '<div class="modal" id="'.concat(e, '"></div>')), !1;
}, $f426e192429150b2$var$s = function(e, t) {
    if (function(e) {
        e.length <= 0 && (console.warn("MicroModal: \u2757Please specify at least one %c'micromodal-trigger'", "background-color: #f8f9fa;color: #50596c;font-weight: bold;", "data attribute."), console.warn("%cExample:", "background-color: #f8f9fa;color: #50596c;font-weight: bold;", '<a href="#" data-micromodal-trigger="my-modal"></a>'));
    }(e), !t) return !0;
    for(var o in t)$f426e192429150b2$var$r(o);
    return !0;
}, {
    init: function(e) {
        var o = Object.assign({}, {
            openTrigger: "data-micromodal-trigger"
        }, e), n = $f426e192429150b2$var$t(document.querySelectorAll("[".concat(o.openTrigger, "]"))), r = function(e, t) {
            var o = [];
            return e.forEach(function(e) {
                var n = e.attributes[t].value;
                void 0 === o[n] && (o[n] = []), o[n].push(e);
            }), o;
        }(n, o.openTrigger);
        if (!0 !== o.debugMode || !1 !== $f426e192429150b2$var$s(n, r)) for(var l in r){
            var c = r[l];
            o.targetModal = l, o.triggers = $f426e192429150b2$var$t(c), $f426e192429150b2$var$a = new $f426e192429150b2$var$i(o);
        }
    },
    show: function(e, t) {
        var o = t || {};
        o.targetModal = e, !0 === o.debugMode && !1 === $f426e192429150b2$var$r(e) || ($f426e192429150b2$var$a && $f426e192429150b2$var$a.removeEventListeners(), ($f426e192429150b2$var$a = new $f426e192429150b2$var$i(o)).showModal());
    },
    close: function(e) {
        e ? $f426e192429150b2$var$a.closeModalByIdOrElement(e) : $f426e192429150b2$var$a.closeModal();
    }
});
"undefined" != typeof window && (window.MicroModal = $f426e192429150b2$var$l);
var $f426e192429150b2$export$2e2bcd8739ae039 = $f426e192429150b2$var$l;


function $dd37e16e4d7b4c60$export$c8b1378226228eb6(modalId) {
    const modalContainer = document.getElementById(modalId);
    if (modalContainer) modalContainer.addEventListener("click", (e)=>{
        const anchor = e.target.closest('a[href^="#"]');
        if (!anchor) return;
        if (e.target.classList.contains("dropdown__trigger")) return;
        MicroModal.close(modalId);
    });
}


const $e9faea94d6c41454$export$650cc1adfbebd6d7 = {
    requiredFieldsId: [
        "nom",
        "prenom",
        "societe",
        "email",
        "telephone"
    ],
    form: null,
    init: (formId)=>{
        $e9faea94d6c41454$export$650cc1adfbebd6d7.form = document.getElementById(formId);
        $e9faea94d6c41454$export$650cc1adfbebd6d7.form.addEventListener("submit", $e9faea94d6c41454$export$650cc1adfbebd6d7.handleSubmit);
    },
    handleSubmit: async (event)=>{
        event.preventDefault();
        if (!$e9faea94d6c41454$export$650cc1adfbebd6d7.form) return;
        $e9faea94d6c41454$export$650cc1adfbebd6d7.clearErrors();
        const formData = new FormData($e9faea94d6c41454$export$650cc1adfbebd6d7.form);
        const data = Object.fromEntries(formData.entries());
        const errors = [];
        $e9faea94d6c41454$export$650cc1adfbebd6d7.requiredFieldsId.forEach((id)=>{
            if (!data[id] || data[id].trim() === "") errors.push({
                id: id,
                message: "Ce champ ne peut \xeatre vide"
            });
        });
        if (data.email.trim()) {
            if (!$e9faea94d6c41454$export$650cc1adfbebd6d7.isValidEmail(data.email)) errors.push({
                id: "email",
                message: "Email invalide"
            });
        }
        const formAlert = $e9faea94d6c41454$export$650cc1adfbebd6d7.form.querySelector(".form__submit__message");
        if (errors.length > 0) {
            errors.forEach((error)=>$e9faea94d6c41454$export$650cc1adfbebd6d7.showFieldError(error.id, error.message));
            formAlert.innerText = "Veuillez corriger le formulaire et envoyer \xe0 nouveau";
            formAlert.classList.add("error");
        } else {
            const response = await fetch($e9faea94d6c41454$export$650cc1adfbebd6d7.form.action, {
                method: $e9faea94d6c41454$export$650cc1adfbebd6d7.form.method,
                headers: {
                    Accept: "application/json"
                },
                body: formData
            });
            if (response.ok) {
                formAlert.innerText = "Votre demande de contact a bien \xe9t\xe9 recue, nous reviendrons vers vous tr\xe8s prochainement";
                formAlert.classList.add("success");
                $e9faea94d6c41454$export$650cc1adfbebd6d7.form.reset();
            } else {
                formAlert.innerText = "Une erreur est survenue, veuillez r\xe9essayer";
                formAlert.classList.add("error");
            }
        }
        formAlert.classList.add("show");
    },
    clearErrors: ()=>{
        const errors = $e9faea94d6c41454$export$650cc1adfbebd6d7.form.querySelectorAll(".error__message");
        errors.forEach((error)=>{
            error.classList.remove("show");
            error.classList.remove("not-valid");
            $e9faea94d6c41454$export$650cc1adfbebd6d7.form.classList.remove("form-not-valid");
            error.innerText = "";
        });
    },
    showFieldError (fieldId, message) {
        const field = $e9faea94d6c41454$export$650cc1adfbebd6d7.form.querySelector(`#${fieldId}`);
        const parent = field.parentElement;
        const el = parent.querySelector(".error__message");
        el.innerText = message;
        el.classList.add("show");
        field.classList.add("not-valid");
        $e9faea94d6c41454$export$650cc1adfbebd6d7.form.classList.add("form-not-valid");
    },
    isValidEmail (email) {
        const regexEmail = new RegExp("^[a-zA-Z0-9.!#$%&'*+\\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)+$");
        return regexEmail.test(email.trim());
    }
};


/**
 * Appliquer un délai à l'éxécution de la fonction callback
 * @param {function} callback
 * @param {number} delay
 * @returns {function}
 */ const $d3f57ad2c92e16fe$export$61fc7d43ac8f84b0 = function(callback, delay) {
    let timer;
    return function test() {
        let args = arguments;
        let context = this;
        clearTimeout(timer);
        timer = setTimeout(function() {
            callback.apply(context, args);
        }, delay);
    };
};


const $f9eb267bbd1ca253$export$38e42c68cf43b5d4 = {
    lastScroll: 0,
    headerBands: document.querySelector(".header__bands"),
    headerNav: document.querySelector(".header__nav"),
    headerContact: document.querySelector(".header__contact--mobile"),
    headerBandsHeight: null,
    headerNavHeight: null,
    headerContactHeight: null,
    windowWidth: null,
    init: ()=>{
        $f9eb267bbd1ca253$export$38e42c68cf43b5d4.headerNavHeight = parseInt(window.getComputedStyle($f9eb267bbd1ca253$export$38e42c68cf43b5d4.headerNav).height);
        $f9eb267bbd1ca253$export$38e42c68cf43b5d4.headerContactHeight = parseInt(window.getComputedStyle($f9eb267bbd1ca253$export$38e42c68cf43b5d4.headerContact).height);
        $f9eb267bbd1ca253$export$38e42c68cf43b5d4.headerBandsHeight = $f9eb267bbd1ca253$export$38e42c68cf43b5d4.headerNavHeight + $f9eb267bbd1ca253$export$38e42c68cf43b5d4.headerContactHeight;
        $f9eb267bbd1ca253$export$38e42c68cf43b5d4.windowWidth = window.innerWidth;
        window.addEventListener(// récupérer la hauteur de la nav qui peut changer selon la largeur de la fenêtre (@mediaquery)
        "resize", (0, $d3f57ad2c92e16fe$export$61fc7d43ac8f84b0)(()=>$f9eb267bbd1ca253$export$38e42c68cf43b5d4.recalculateHeaderHeight(), 500));
        window.addEventListener("scroll", $f9eb267bbd1ca253$export$38e42c68cf43b5d4.handleScroll, {
            passive: true
        });
        const dropdownTriggerBtns = document.querySelectorAll(".dropdown__trigger");
        dropdownTriggerBtns.forEach((el)=>{
            el.addEventListener("click", (e)=>{
                // Empecher au clic sur le lien trigger du dropdown de remonter en haut de la page
                e.preventDefault();
            });
        });
    },
    recalculateHeaderHeight: ()=>{
        if (!$f9eb267bbd1ca253$export$38e42c68cf43b5d4.windowWidth) return;
        if ($f9eb267bbd1ca253$export$38e42c68cf43b5d4.windowWidth !== window.innerWidth) {
            $f9eb267bbd1ca253$export$38e42c68cf43b5d4.headerNavHeight = parseInt(window.getComputedStyle($f9eb267bbd1ca253$export$38e42c68cf43b5d4.headerNav).height);
            $f9eb267bbd1ca253$export$38e42c68cf43b5d4.headerContactHeight = parseInt(window.getComputedStyle($f9eb267bbd1ca253$export$38e42c68cf43b5d4.headerContact).height);
            $f9eb267bbd1ca253$export$38e42c68cf43b5d4.headerBandsHeight = $f9eb267bbd1ca253$export$38e42c68cf43b5d4.headerNavHeight + $f9eb267bbd1ca253$export$38e42c68cf43b5d4.headerContactHeight;
        }
    },
    handleScroll: ()=>{
        if (!$f9eb267bbd1ca253$export$38e42c68cf43b5d4.headerBands || !$f9eb267bbd1ca253$export$38e42c68cf43b5d4.headerBandsHeight) return;
        const dropdownMenus = document.querySelectorAll(".dropdown__menu");
        let currentScroll = window.scrollY;
        if (currentScroll < $f9eb267bbd1ca253$export$38e42c68cf43b5d4.headerBandsHeight) return;
        if (currentScroll <= 0) {
            $f9eb267bbd1ca253$export$38e42c68cf43b5d4.headerBands.classList.remove("scroll-up");
            return;
        }
        if (currentScroll > $f9eb267bbd1ca253$export$38e42c68cf43b5d4.lastScroll) {
            dropdownMenus.forEach((dropdown)=>{
                dropdown.classList.remove("show");
            });
            $f9eb267bbd1ca253$export$38e42c68cf43b5d4.headerBands.classList.add("scroll-down");
            $f9eb267bbd1ca253$export$38e42c68cf43b5d4.headerBands.classList.remove("scroll-up");
        }
        if (currentScroll < $f9eb267bbd1ca253$export$38e42c68cf43b5d4.lastScroll) {
            $f9eb267bbd1ca253$export$38e42c68cf43b5d4.headerBands.classList.add("scroll-up");
            $f9eb267bbd1ca253$export$38e42c68cf43b5d4.headerBands.classList.remove("scroll-down");
        }
        $f9eb267bbd1ca253$export$38e42c68cf43b5d4.lastScroll = currentScroll;
    }
};


document.addEventListener("DOMContentLoaded", ()=>{
    (0, $f426e192429150b2$export$2e2bcd8739ae039).init({
        openClass: "show",
        disableScroll: true,
        awaitCloseAnimation: true
    });
    (0, $dd37e16e4d7b4c60$export$c8b1378226228eb6)("modal-menu-mobile");
    (0, $f9eb267bbd1ca253$export$38e42c68cf43b5d4).init();
    const dropdownContainers = document.querySelectorAll(".dropdown__container");
    dropdownContainers.forEach((el)=>new (0, $bcb8d116ab6e5930$export$931cbfb6bfb85fc)(el));
    (0, $e9faea94d6c41454$export$650cc1adfbebd6d7).init("form-contact");
});


//# sourceMappingURL=cleriam.0fc385db.js.map
